// extracted by mini-css-extract-plugin
module.exports = {"cursor":"ReloveIconLike_cursor__5a6cx","root":"ReloveIconLike_root__4dK-b"};